import {createSlice} from '@reduxjs/toolkit';
import {setLocalStorage} from '@/core/utils/saveDataToLocalStorage.js';

const initialState = {
    durations: [],
    localStorageKey: '',
}

const durationSlice = createSlice({
    name: 'duration',
    initialState,
    reducers: {
        setDurationLocalStorageKey(state, action) {
            state.localStorageKey = action.payload
        },

        addDuration (state, action){
            const { activeQuestion, durationInSeconds } = action.payload;

            // Calculate the summary duration for the active question
            let summaryDuration = durationInSeconds;
            if (state.durations[activeQuestion]) {
                summaryDuration += state.durations[activeQuestion];
            }

            state.durations[activeQuestion] = summaryDuration;
        },

        updateDurations(state, action) {
            state.durations = [...action.payload]
        },

        resetDurationsState(state) {
            state.durations = []
        }
    }
})

export const {
    addDuration,
    setDurationLocalStorageKey,
    updateDurations,
    resetDurationsState,
} = durationSlice.actions

export default durationSlice.reducer

export const calculateDuration = (activeQuestion) => (dispatch) => {
    let startTime = new Date().getTime(); // Start time of the current question

    return () => {
        // Cleanup function to calculate duration when the activeQuestion changes

        let endTime = new Date().getTime(); // End time of the previous question
        let durationInSeconds = Math.floor((endTime - startTime) / 1000); // Calculate the duration in seconds

        dispatch(addDuration({ activeQuestion, durationInSeconds }));
        dispatch(setDurationsToLocalStorage());
    };
}

export const setDurationsToLocalStorage = () => (dispatch, getState) => {
    const storedItemKey = getState().duration.localStorageKey;
    const durations = getState().duration.durations;

    if (storedItemKey) {
        setLocalStorage(storedItemKey, durations);
    }
}

export const getDurationsFromLocalStorage = (key) => (dispatch) => {
    let storedDurations = JSON.parse(localStorage.getItem(key)) || [];
    dispatch(updateDurations(storedDurations));
}
